<template>
    <vue-scroll :ops="$ops">
        <div v-loading="$parentInfo.studentCart.dialog_ChooseLesson.loading">
            购物车
            <table class="table">
                <thead>
                <tr>
                    <th>班级</th>
                    <th>年级</th>
                    <th>学科</th>
                    <th>班型</th>
                    <th>课时</th>
                    <th>挑选课时</th>
                    <th>使用课时</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index1) in $parentInfo.studentCart.dialog_ChooseLesson.studentCarts" :key="item.id">
                    <td>
                        <el-button size='mini' @click="handleAddLesson(index1)">+</el-button>
                        {{item.classx.name}}
                    </td>
                    <td>{{item.grade.name}}</td>
                    <td>{{item.subject.name}}</td>
                    <td>{{item.class_type.name}}</td>
                    <td>{{item.period}}</td>
                    <td>
                        <div v-for="(studentLesson_id,index) in item.studentLessons_id" :key="studentLesson_id.id">
                            <el-select v-model="item.studentLessons_id[index]"
                                       placeholder="请选择科目">
                                <el-option
                                        v-for="item1 in item.studentLessons_use"
                                        :key="item1.id"
                                        :label="item1.name"
                                        :value="item1.id"
                                >
                                    <!--:disabled="limit"-->
                                </el-option>
                            </el-select>
                            <el-button size='mini' @click="handleDelLesson(index1,index)">-</el-button>
                        </div>
                    </td>
                    <td>
                        <div v-for="(studentLesson_period,index) in item.studentLessons_period"
                             :key="studentLesson_period.id">
                            <el-input v-model="item.studentLessons_period[index]"
                                      @change="judgePeriod(index1,index)"></el-input>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <hr class="m-t-0 m-b-40">
            剩余课时
            <table class="table" v-loading="$parentInfo.studentCart.dialog_ChooseLesson.loading">
                <thead>
                <tr>
                    <th>年级</th>
                    <th>学科</th>
                    <th>班型</th>
                    <th>单价</th>
                    <th>剩余课时</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in orderStudentLessons" :key="item.id">
                    <td>{{item.grade.name}}</td>
                    <td>{{item.subject.name}}</td>
                    <td>{{item.class_type.name}}</td>
                    <td>
                        <div>{{item.unit_period_price}}</div>
                    </td>
                    <td>{{item.period}}</td>
                </tr>
                </tbody>
            </table>
            <div slot="footer" class="dialog-footer" align="right">
                <el-button type="primary" size="small"
                           :loading="$parentInfo.studentCart.dialog_ChooseLesson.button_loading"
                           :disabled=isDisabled
                           @click="handleCheck()">确 定
                </el-button>
            </div>
        </div>
    </vue-scroll>
</template>

<script>
    export default {
        name: 'Dialog_ChooseLesson',
        data() {
            return {
                isDisabled: false,
            };
        },
        computed: {
            orderStudentLessons: function () {
                return this._.orderBy(this.$parentInfo.studentCart.dialog_ChooseLesson.studentLessons, 'id', 'desc');
            },
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleGetLesson();
        },
        methods: {
            // 查找相同课程下班级信息
            handleGetLesson() {
                this.$wApi.send(this.$parentInfo.path, 'getLessonInCart', {
                    'student_id': this.$parentInfo.student_id,
                    'selections': this.$store.state.modal.data.selections,
                });
            },
            handleCheck() {
                this.$parentInfo.studentCart.dialog_ChooseLesson.button_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'check', {
                    'student_id': this.$parentInfo.student_id,
                    'studentCarts': this.$parentInfo.studentCart.dialog_ChooseLesson.studentCarts,
                });
                // this.$axios.post(store.state.server + '/studentCart/chooseLesson?'
            },
            judgePeriod(index1, index) {
                if (this.$parentInfo.studentCart.dialog_ChooseLesson.studentCarts[index1].studentLessons_period[index] > this.$parentInfo.studentCart.dialog_ChooseLesson.studentCarts[index1].studentLessons_use[this.$parentInfo.studentCart.dialog_ChooseLesson.studentCarts[index1].studentLessons_id[index]].has_period) {
                    this.$message({
                        showClose: true,
                        message: '使用课时不能大于实际课时',
                        type: 'warning'
                    });
                    this.isDisabled = true
                }else{
                    this.isDisabled = false
                }
            },
            handleAddLesson(index) {
                this.$parentInfo.studentCart.dialog_ChooseLesson.studentCarts[index].studentLessons_id.push('');
                this.$parentInfo.studentCart.dialog_ChooseLesson.studentCarts[index].studentLessons_period.push(0);
            },
            handleDelLesson(index1, index) {
                this.$parentInfo.studentCart.dialog_ChooseLesson.studentCarts[index1].studentLessons_id.splice(index, 1);
                this.$parentInfo.studentCart.dialog_ChooseLesson.studentCarts[index1].studentLessons_period.splice(index, 1);
            },

        }
    };
</script>

<style scoped>

</style>
